import React from "react";
import { useTranslation } from "react-i18next";
import { GiCheckMark } from "react-icons/gi";

export const DiscoverInvozio = () => {
  const { t } = useTranslation();

  return (
    <div className="content_new lorem">
      <h3>{t("Discover Invozio")}</h3>
      <p
        className="font-weight-bold"
        style={{ fontSize: "24px", color: "#343a40" }}
      >
        {t("Simple billing with no hidden fees and flexible support")}
      </p>
      <ul>
        <li>
          <p>
            <GiCheckMark />
          </p>
          <div>
            <h6 className="font-weight-bold">{t("No fixation")}</h6>
            {t("create your account at Invozio.com completely free of charge!")}
          </div>
        </li>
        <li>
          <p>
            <GiCheckMark />
          </p>
          <div>
            <h6 className="font-weight-bold">
              {t("We take care of all administrative handling")}
            </h6>
            {t("including accounting and handling of tax payments")}
          </div>
        </li>
        <li>
          <p>
            <GiCheckMark />
          </p>
          <div>
            <h6 className="font-weight-bold">{t("No fixed monthly fee")}</h6>
            {t(
              "instead, you pay only 1.4% of the invoice amount at each invoicing occasion"
            )}
          </div>
        </li>

        <li>
          <p>
            <GiCheckMark />
          </p>
          <div>
            <h6 className="font-weight-bold">
              {t("Professional support and qualified advice")}
            </h6>
            {t("by email or phone, every non-holiday weekday.")}
          </div>
        </li>
      </ul>
    </div>
  );
};
